// Used in assignable-expanded-singular, modify-teacher-class-assignment, assignable-preview-details, tiles.component, page-header

import { Injectable } from "@angular/core";

@Injectable()
export class GetDiscoverActivityTypeNameHelper {
    constructor() {}

    // format an assignment's activity type
    public getDiscoverActivityTypeName(activityType: string) {
        switch (activityType) {
            case "fib":
                return "Fill in the Blank";
            case "mc":
                return "Multiple Choice";
            case "mtc":
                return "Matching";
            case "qa":
                return "Question and Answer";
            case "text":
                return "Text";
            case "tf":
                return "True or False";
            case "wordbank":
                return "Wordbank";
            case "ata":
                return "All That Apply";
            default:
                return "---";
        }
    }
}
